/** Curated reference content for Studio → Extensions & tools (always shown as examples). */
export const BUNDLED_EXTENSION_EXAMPLES = [
  {
    id: 'com.chatbot.core',
    name: 'Core Studio Nodes',
    description: 'Built-in flow nodes, app controls, and system MCP tools. Always enabled.',
    badges: ['Always on', '53+ nodes'],
    highlights: ['LLM / AI Agent', 'API call', 'RAG', 'Form input', 'web_search'],
  },
  {
    id: 'com.chatbot.interviewflow',
    name: 'InterviewFlow',
    description: 'Recruiting + SF permit advisor skills, panel export, webhooks, and application-type tooling.',
    badges: ['Default on', 'skills', 'MCP tools'],
    highlights: ['if-sf-application-advisor', 'if_lookup_sf_parcel', 'if_advise_application_type', 'if-recruiting-screener'],
  },
  {
    id: 'com.chatbot.clio',
    name: 'Clio Legal',
    description: 'Legal practice integration — conflict check, matters, time entries, documents.',
    badges: ['Professional plan', '4 nodes', '2 MCP tools'],
    highlights: ['clio-conflict-check', 'clio_search_matters', 'OAuth via /api/clio'],
  },
];

export const EXAMPLE_TOOLS = [
  {
    id: 'builtin.web_search',
    name: 'web_search',
    description: 'Search the web from an agent or mcp-tool node.',
    source: 'builtin',
    extensionId: 'com.chatbot.core',
  },
  {
    id: 'builtin.file_system_read',
    name: 'file_system_read',
    description: 'Read files from the filesystem (tenant-permitting).',
    source: 'builtin',
    extensionId: 'com.chatbot.core',
  },
  {
    id: 'if_export_panel_json',
    name: 'if_export_panel_json',
    description: 'Export app panel data as JSON (InterviewFlow).',
    source: 'extension',
    extensionId: 'com.chatbot.interviewflow',
  },
  {
    id: 'if_webhook_on_complete',
    name: 'if_webhook_on_complete',
    description: 'Fire a webhook when an interview flow completes.',
    source: 'extension',
    extensionId: 'com.chatbot.interviewflow',
  },
  {
    id: 'if_lookup_sf_parcel',
    name: 'if_lookup_sf_parcel',
    description: 'Geocode SF address → parcel (mapblklot), zoning, and constraint flags from Planning GIS.',
  },
  {
    id: 'if_advise_application_type',
    name: 'if_advise_application_type',
    description: 'Advise SF permit vs planning vs license from citizen project intent (city catalog).',
    source: 'extension',
    extensionId: 'com.chatbot.interviewflow',
  },
  {
    id: 'clio_search_matters',
    name: 'clio_search_matters',
    description: 'Search Clio matters (requires Clio OAuth).',
    source: 'extension',
    extensionId: 'com.chatbot.clio',
  },
  {
    id: 'flow.example',
    name: 'flow.<yourFlowId>',
    description: 'Any saved V2 flow becomes a callable tool for agents and MCP clients.',
    source: 'flow',
    extensionId: 'com.chatbot.core',
  },
];

export const EXAMPLE_SKILLS = [
  {
    id: 'if-sf-application-advisor',
    name: 'SF application-type advisor',
    description: 'Flagship CLAW skill demo: agent tool loop over parcel GIS + catalog advise capabilities; SF permit use case.',
    extensionId: 'com.chatbot.interviewflow',
    allowedTools: ['if_lookup_sf_parcel', 'if_advise_application_type', 'builtin.web_search', 'if_export_panel_json'],
  },
  {
    id: 'if-recruiting-screener',
    name: 'Recruiting Screener',
    description: 'Structured candidate screening rubric with export tool access.',
    extensionId: 'com.chatbot.interviewflow',
    allowedTools: ['if_export_panel_json', 'builtin.web_search'],
  },
  {
    id: 'if-scorecard-interviewer',
    name: 'Scorecard Interviewer',
    description: 'Turn interview notes into scorecard JSON with evidence.',
    extensionId: 'com.chatbot.interviewflow',
    allowedTools: ['if_export_panel_json'],
  },
  {
    id: 'studio-v2-workflow-builder',
    name: 'V2 Workflow Builder',
    description: 'AI assistant for authoring flow/v2 definitions in Studio.',
    extensionId: 'com.chatbot.interviewflow',
    allowedTools: [],
  },
];

export const SAMPLE_SIDELOAD_MANIFEST = {
  schemaVersion: '1.0',
  id: 'com.example.demo-tools',
  version: '0.1.0',
  name: 'Demo Tools (example)',
  description: 'Example sideload manifest — registers one MCP tool for your tenant.',
  tenantPolicy: { defaultEnabled: true },
  capabilities: [
    {
      id: 'demo.tools',
      kind: 'mcp-tool-bundle',
      tools: [
        {
          id: 'demo_hello',
          name: 'demo_hello',
          description: 'Returns a greeting for smoke-testing the tool catalog',
          source: 'extension',
        },
      ],
    },
  ],
};

export const TOOL_SOURCE_LABELS = {
  builtin: 'Built-in',
  extension: 'Extension',
  'connector-op': 'Connector',
  'flow-node': 'Flow',
  flow: 'Your flow',
};
